<template>
    <main class="min-h-screen bg-background  overflow-hidden">
        <UnderwaterBg class="fixed inset-0 z-0" />
        
        <div class="relative z-10 flex min-h-screen items-center justify-center p-4">
            <div class="w-full max-w-md space-y-8">
                <div class="text-center mb-8">
                    <img src="/ducksImages/duckIcon.webp" class="w-24 h-24 mx-auto mb-6 drop-shadow-lg" />
                    <h1 class="text-4xl font-bold text-white drop-shadow-lg">New Password</h1>
                </div>

                <div class="backdrop-blur-sm bg-white/80 rounded-2xl p-8 shadow-xl space-y-6">
                    <form class="space-y-6" @submit.prevent="handleSubmit">
                        <div>
                            <label class="block text-sm font-medium text-gray-700">New Password</label>
                            <input
                                v-model="form.password"
                                type="password"
                                required
                                class="mt-1 block w-full rounded-lg border border-gray-300 px-4 py-3 shadow-sm"
                                placeholder="Enter new password"
                            />
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700">Confirm Password</label>
                            <input
                                v-model="form.confirmPassword"
                                type="password"
                                required
                                class="mt-1 block w-full rounded-lg border border-gray-300 px-4 py-3 shadow-sm"
                                placeholder="Confirm new password"
                            />
                        </div>

                        <div v-if="error" class="text-red-600 text-sm text-center">
                            {{ error }}
                        </div>

                        <v-btn
                            type="submit"
                            :loading="loading"
                            block
                            color="primary"
                            size="large"
                            class="rounded-lg"
                        >
                            Reset Password
                        </v-btn>
                    </form>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from '@/plugins/axios';
import { Constant } from '@/config/constants';
import { UnderwaterBg } from '@/components/ui/underwaterBg';

const route = useRoute();
const router = useRouter();
const loading = ref(false);
const error = ref('');

const form = reactive({
    password: '',
    confirmPassword: ''
});

const handleSubmit = async () => {
    if (loading.value) return;
    error.value = '';

    if (form.password !== form.confirmPassword) {
        error.value = 'Passwords do not match';
        return;
    }

    try {
        loading.value = true;
        const token = route.query.token as string;

        if (!token) {
            error.value = 'Invalid reset link';
            return;
        }

        await axios.post(Constant.API_URL + Constant.RESET_PASSWORD, {
            token,
            newPassword: form.password
        });

        // Redirect to home with login dialog and success message
        router.push({
            path: '/',
            query: { 
                showLogin: 'true',
                message: 'Password reset successful. Please login with your new password.',
                status: 'success'
            }
        });
    } catch (err: any) {
        if (err.response?.status === 404) {
            error.value = 'Invalid reset link';
        } else if (err.response?.status === 410) {
            error.value = 'This reset link has expired. Please request a new one.';
        } else if (err.response?.status === 400) {
            error.value = 'Password must be at least 8 characters long';
        } else {
            error.value = 'An error occurred. Please try again.';
        }
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    if (!route.query.token) {
        router.push('/forgot-password');
    }
});
</script>
